const steps = [
  {
    n: "01",
    title: "Open your browser side panel.",
    sub: "One click from the toolbar.",
  },
  {
    n: "02",
    title: "Mindrail reads your current work state.",
    sub: "Live signals, fully on-device.",
  },
  {
    n: "03",
    title: "Click I'm Frozen, Clean Mode, or Just One Thing.",
    sub: "Choose the support that fits the moment.",
  },
  {
    n: "04",
    title: "Get one small action.",
    sub: "Tiny enough to actually start.",
  },
  {
    n: "05",
    title: "Keep going, or stop without guilt.",
    sub: "Both are valid.",
  },
];

export default function HowItWorks() {
  return (
    <section
      id="how"
      data-testid="how-section"
      className="px-6 lg:px-10 py-24 lg:py-32 bg-[#F1F5F9]/50"
    >
      <div className="max-w-6xl mx-auto">
        <div className="fade-up max-w-3xl">
          <p className="text-sm tracking-[0.18em] uppercase font-semibold text-[#475569]">
            How it works
          </p>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight font-medium leading-[1.05]">
            From stuck to moving in under a minute.
          </h2>
        </div>

        <ol className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {steps.map((s, i) => (
            <li
              key={i}
              data-testid={`how-step-${i}`}
              className="fade-up bg-white border border-[#E2E8F0] rounded-3xl p-6 flex flex-col gap-4 hover:-translate-y-1 transition-transform duration-500"
              style={{ transitionDelay: `${i * 70}ms` }}
            >
              <span className="font-mono text-xs text-[#F59E0B]">{s.n}</span>
              <p className="font-display text-lg text-[#0F172A] leading-snug">
                {s.title}
              </p>
              <p className="mt-auto text-sm text-[#475569]">{s.sub}</p>
            </li>
          ))}
        </ol>

        <div className="mt-12 fade-up">
          <a
            href="#"
            data-testid="how-cta"
            className="inline-flex items-center gap-2 rounded-full bg-[#22C55E] hover:bg-[#16A34A] text-white px-7 py-4 text-base font-medium transition-all hover:scale-[1.02]"
          >
            Try your first tiny step
          </a>
        </div>
      </div>
    </section>
  );
}
